// @ts-nocheck
import {Column} from 'react-table'
import {CustomHeader} from './CustomHeader'
import {SelectionHeader} from './SelectionHeader'
import {User} from '../../core/_models'
import {CustonCell} from './CustonCell'
import {formatMask, formatMonetaryToBr} from '../../../../../../../utils/formatMonetaryToBr'
import {formatDate} from '../../../../../../../utils/dayJs/format'

const ReportSalesColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Data Contrato' className='min-w-125px' />
    ),
    id: 'contract_date',
    Cell: ({...props}) => (
      <CustonCell
        value={
          props.data[props.row.index].contract_date
            ? formatDate(props.data[props.row.index].contract_date)
            : ''
        }
      />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Contrato' className='min-w-125px' />,
    id: 'contract',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].contract} />,
  },

  {
    Header: (props) => <CustomHeader tableProps={props} title='Cliente' className='min-w-125px' />,
    id: 'client_name',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].client_name} />,
  },

  {
    Header: (props) => <CustomHeader tableProps={props} title='unidade' className='min-w-125px' />,
    id: 'franchiseName',
    Cell: ({...props}) => <CustonCell value={`${props.data[props.row.index].franchiseName}`} />,
  },

  {
    Header: (props) => <CustomHeader tableProps={props} title='Valor' className='min-w-125px' />,
    id: 'amount',
    Cell: ({...props}) => <CustonCell value={formatMask(props.data[props.row.index].amount)} />,
  },

  {
    Header: (props) => <CustomHeader tableProps={props} title='Parcela' className='min-w-125px' />,
    id: 'installment_number',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].installment_number} />,
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Data Vencimento' className='min-w-125px' />
    ),
    id: 'dueDate',
    Cell: ({...props}) => (
      <CustonCell
        value={
          props.data[props.row.index].due_date
            ? formatDate(props.data[props.row.index].due_date)
            : ''
        }
      />
    ),
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Data Situação' className='min-w-50px' />
    ),
    id: 'situation_date',
    Cell: ({...props}) => (
      <CustonCell
        value={
          props.data[props.row.index].situation_date
            ? formatDate(props.data[props.row.index].situation_date)
            : ''
        }
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Forma de Pagamento' className='min-w-50px' />
    ),
    id: 'payment_option',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].payment_option} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-50px' />,
    id: 'status_name',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].status_name} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Motivo Rejeitada' className='min-w-50px' />
    ),
    id: 'rejected_reason',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].rejected_reason} />,
  },
]

export {ReportSalesColumns}
